/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
//  Code modified on 2019/02/25
**********************************************************************/

<template>
	<div>
		<v-container fluid grid-list-lg>
			<v-card v-if="this.isComponent('admin-control')" class="hoverable" xl4 l4 xs4>

				<v-data-table :items="dataSet" :headers="headers" class="elevation-1 " hide-actions>
					<template slot="items" slot-scope="props">
						<td>B{{ props.item.block_id}}-R{{ props.item.room_id}}-INV{{ props.item.inverter_id}}</td>
						<td>
							<v-flex xl4 l4 xs4>
								<v-text-field :rules="generationRules"
									:value="props.item.inverter_dc_capacity ? props.item.inverter_dc_capacity : 0"
									@change="update(props.item.id,$event)" solo box></v-text-field>
							</v-flex>
						</td>
					</template>
				</v-data-table>
				<v-btn color="success" @click="submit()">Submit</v-btn>
			</v-card>
			<no-device v-else :message="subscriptionMessage"></no-device>

			<v-dialog v-model="dialog" max-width="500px">
				<v-card height="150px">
					<v-card-title>
						<v-flex xs11 sm11>
							<div class="text-md-center">
								<v-icon>thumb_up</v-icon>
								<div>UPDATED SUCCESSFULLY</div>
							</div>
						</v-flex>
					</v-card-title>
					<v-card-actions>
						<v-flex xs10 sm11>
							<div class="text-md-center">
								<v-btn color="primary" @click="dialog=false" left>Close</v-btn>
							</div>
						</v-flex>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import control from '@/services/adminControl'

const NoDevice = () => import('@/components/utility/NoDevice.vue')

export default {
  components: {
    NoDevice
  },
  data() {
    return {
      subscriptionMessage: 'This feature is not applicable for your plant.',
      generationRules: [
        v => !!v || 'Generation is required',
        v => /^\d+\.{0,1}\d{0,2}$/.test(v) || 'Generation must be a number'
      ],
      dataSet: [],
      headers: [{
        text: 'DEVICE',
        value: 'block_id'
      },
      {
        text: 'DC CAPACITY(kW)',
        value: 'dc_capacity',
        align: 'left'
      }
      ],
      updateList: {},
      temp: {},
      dialog: false

    }
  },
  computed: {
    ...mapGetters([
      'getSelectedPlantId',
      'isComponent'
    ])
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      let response = await control.getPlantDetails(this.getSelectedPlantId)
      this.dataSet = response.data.message
    },
    update(id, dc_capacity) {
      this.updateList[id] = dc_capacity
    },
    async submit() {
      let params = {
        plantId: this.getSelectedPlantId,
        list: this.updateList
      }
      let response = await control.updatePlantInfo(params)
      if (response.data.status == 'success') { this.dialog = true }
      this.getData()
    }
  },
  watch: {
    getSelectedPlantId() {
      this.getData()
    }
  }
}
</script>
<style scoped>
    table.v-table tbody td,
table.v-table tbody th {
  height: 10px;
}

table.v-table thead tr {
    height: 36px;
}
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)) {
  padding: 0 6px;
}

.theme--dark .hoverable {
    -webkit-transition: -webkit-box-shadow .25s;
    transition: -webkit-box-shadow .25s;
    transition: box-shadow .25s;
    transition: box-shadow .25s, -webkit-box-shadow .25s;
    transition: all 0.3s ease-in-out;
}

.theme--dark .hoverable {
    -webkit-box-shadow: 0 8px 17px 0 rgba(200, 200, 200, 0.25), 0 6px 20px 0 rgba(200, 200, 200, 0.25);
    box-shadow: 0 8px 17px 0 rgba(200, 200, 200, 0.25), 0 6px 20px 0 rgba(200, 200, 200, 0.25);
}

.theme--light .hoverable {
    -webkit-transition: -webkit-box-shadow .25s;
    transition: -webkit-box-shadow .25s;
    transition: box-shadow .25s;
    transition: box-shadow .25s, -webkit-box-shadow .25s;
    transition: all 0.3s ease-in-out;
}

.theme--light .hoverable {
    -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

</style>
